import React, { useEffect,useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Container, Typography, a } from '@mui/material';
import {Link} from 'react-router-dom'




const useStyles = makeStyles((theme) => ({

  fixFooter: {
    width: '100%',
    position:(props) => props.position,
    display: 'flex',
    textAlign:'space-between',
    gap:'5%',
    padding: '1%',
    background:'#005E8F',
    color:'white',
    [theme.breakpoints.down('md')]: {
      padding: '2% 0% 0% 0%',
      gap:'3%',
      flexDirection: 'column',
    },
  },
  fix_footer_a:{
    textDecoration:'none' ,
    color:'white',
    cursor:'pointer',
    '&:hover':{
      color:'#fff'
    }
  },
  rght: {
    width: '40%',
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  rght_h6: {
    fontWeight: 500,
    letterSpacing: '-0.7px',
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
  
    },
  },
  lft: {
    width: '60%',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1%',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      paddingTop: '1.5%',
      width: '100%',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  lft_h6: {
    fontWeight: 500,
    letterSpacing: '-0.7px',
    [theme.breakpoints.down('md')]: {
      fontSize: '1em'
    }
  },


  
}));

const Footer = () => {
  var [position,setPosition]=useState((document.body.offsetHeight/window.innerHeight)*100<100?'absolute':'static');
  const classes = useStyles({position});

  useEffect(
    ()=>{
      var height=window.innerHeight;
      window.addEventListener('readystatechange', function() {
        {(document.body.offsetHeight/height)*100<100?setPosition('absolute'):setPosition('static')}
      })
      
      window.addEventListener('resize',()=>{
    
  
        {(document.body.offsetHeight/height)*100<100?setPosition('absolute'):setPosition('static')}
        console.log(position)
        
       })
    }
  )

  
  return (
   <>

    <div className={classes.fixFooter}>
          <div className={classes.rght}>
           <Link to='#' className={classes.fix_footer_a}> <h6 className={classes.rght_h6}> &copy; {new Date().getFullYear()} Trending Data HUB. All Rights Reserved</h6></Link>
          </div>
          <div className={classes.lft}>
            <Link  to={`/privacy-policy`} className={classes.fix_footer_a}><h6 className={classes.lft_h6}>Privacy Statements </h6></Link> <h6 className={classes.lft_h6}>|</h6>
            <Link  to={`/terms-of-service`}  className={classes.fix_footer_a}><h6 className={classes.lft_h6}>Digital Terms of Sale </h6></Link> <h6 className={classes.lft_h6}>|</h6>
            <Link to='#' className={classes.fix_footer_a}><h6 className={classes.lft_h6}>To report security issues email us at security@trendingdatahub.com</h6></Link>
         
          
          </div>
        </div>
   </>
  );
};

export default Footer;
